import { type ComponentProps } from 'react';

const WarningIcon = (props: ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    {...props}
    viewBox="0 0 20 20"
  >
    <g clipPath="url(#clip0_5738_34518)">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M10 13.334V10m0-3.333h.009m-6.8.517a3.333 3.333 0 0 1 3.983-3.975 3.333 3.333 0 0 1 5.617 0 3.333 3.333 0 0 1 3.983 3.983 3.333 3.333 0 0 1 0 5.617 3.333 3.333 0 0 1-3.975 3.983 3.334 3.334 0 0 1-5.625 0 3.333 3.333 0 0 1-3.983-3.975 3.333 3.333 0 0 1 0-5.633"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_5738_34518">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default WarningIcon;